import React, { useEffect, useState } from "react";
import { Accordion, Alert, Button, Card, Col, Container, Image, Row, Tab, Tabs } from "react-bootstrap";
import Desplegable from "../desplegable";
import * as utils from "../../utils.js";

// Usuario
import DesplegableDatosPersonales from "./desplegables/desplegable_datos_personales";
import DesplegableTipoFormacion from "./desplegables/desplegable_tipo_formacion";
import { DesplegableFormacionAdicional } from "./desplegables/desplegable_formacion_adicional";
import TabCambioContrasena from "./desplegables/desplegable_cambio_contraseña";

// Hermana
import DesplegableSacramental from "../hermana/desplegables/desplegable_sacramental";
import DesplegableDeceso from "../hermana/desplegables/desplegable_deceso";
import DesplegableTestamento from "../hermana/desplegables/desplegable_testamento";
import DesplegableFamiliares from "../hermana/desplegables/desplegable_familiares";
import DesplegableContacto from "../hermana/desplegables/desplegable_contacto";
import DesplegableDatosSTJ from "../hermana/desplegables/desplegable_datos_STJ";
import DesplegableFormacionReligiosa from "../hermana/desplegables/desplegable_formacion_religiosa";
import SituacionesParticulares from "../hermana/desplegables/SituacionesParticulares";
import VidaReligiosa from "../hermana/desplegables/VidaReligiosa";
import { getUserData } from "../../services/usuario/usuario";
import DesplegableCargos from "./desplegables/desplegable_cargos";
import CursosCompania from "../hermana/desplegables/CursosCompania";
import DestinoLaico from "./DestinoLaico";
import DestinoHermana from "../hermana/DestinoHermana";
import EtapasVidaReligiosa from "../hermana/desplegables/EtapasVidaReligiosa";
import MisionDocumentos from "../provincia/misiones/MisionDocumentos";
import MisionExtra from "../hermana/desplegables/misionExtra";
import { informeHermanaCompleto } from "../../reports/informes";

const Usuario = (props) => {

    const [DatosUsuario, setDatosUsuario] = useState({});
    const [showModalMatrix, setShowModalMatrix] = useState([]);
    const [loading, setLoading] = useState(true);
    //const userID = props.perfil.id;
    const userID = props.computedMatch.params.id ? props.computedMatch.params.id : props.perfil.id
    // console.log(props.computedMatch.params.id+"esto pasa aqui"+props.perfil.id)
    // console.log(props)

    // Lo primero que se hace al cargar este componente es hacer un get de todos los datos de la hermana
    // Despues carga los showModal en la matriz del estado

    const loadModalMatrix = (data) => {
        let dullShowMatrix = [];
        dullShowMatrix.push(false); // [0] controla modal datos personales
        dullShowMatrix.push(false); // [1] controla modal de tipo formacion
        dullShowMatrix.push(utils.falseArray(data.datosTipoFormacion.estudios)); // [2][n] controla los modales del tipServicios vio formacion
        dullShowMatrix.push(false); // [3] controla modal de informatica
        dullShowMatrix.push(utils.falseArray(data.datosInformatica)); // [4][n] controla los modales de informatica
        dullShowMatrix.push(false); //[5] controla el modal de idiomas
        dullShowMatrix.push(utils.falseArray(data.datosIdiomas.idiomas)); // [6][n] controla los modales de idiomas
        if (data.sister || data.type === "Monja") {
            dullShowMatrix.push(false); // [7] controla el modal de los datos sacramentales
            dullShowMatrix.push(false); // [8] controla el modal de datos deceso de la hermana
            dullShowMatrix.push(false); // [9] controla el modal de datos testamento de la hermana
            dullShowMatrix.push(false); // [10] controla el modal de los datos familiares
            dullShowMatrix.push(false); // [11] controla el modal de la persona de contacto
            dullShowMatrix.push(false); // [12] controla el modal de los datos STJ
            dullShowMatrix.push(false); //  [13] controla el modal de situaciones particulares de la hermana
            dullShowMatrix.push(utils.falseArray(data.datosPersonales)); // [14][n] controla los modales de situaciones particulares de la hermana
            dullShowMatrix.push(false); // [15] controla el modal de añadir etapas vida religiosa de la hermana
            dullShowMatrix.push(false); // [16][n] controla los modales de las diferentes etapas de la formación de la hermana
            dullShowMatrix.push(false); // [17] controla el modal de formacion religiosa de la hermana
            dullShowMatrix.push(utils.falseArray(data.datosFormacionReligiosa)); // [18][n] controla los modales de las diferentes formaciones religiosas de la hermana
            dullShowMatrix.push(false);  // [19] modal comunidad
            dullShowMatrix.push(utils.falseArray(data.cargos.community)) // [20][n] modales comunidad
            dullShowMatrix.push(false);  // [21] modal provincia
            dullShowMatrix.push(utils.falseArray(data.cargos.province)); // [22][n] modales provincia
            dullShowMatrix.push(false);  // [23] modal equipo
            dullShowMatrix.push(utils.falseArray(data.cargos.workgroup)); // [24][n] modales equipo
            dullShowMatrix.push(false);  // [25] modal mision
            dullShowMatrix.push(utils.falseArray(data.cargos.mission)); // [26][n] modales mision

        } else {
            dullShowMatrix.push(false); // [7] controla el modal de los datos sacramentales
            dullShowMatrix.push(false); // [8] controla el modal de datos deceso de la hermana
            dullShowMatrix.push(false); // [9] controla el modal de datos testamento de la hermana
            dullShowMatrix.push(false); // [10] controla el modal de los datos familiares
            dullShowMatrix.push(false); // [11] controla el modal de la persona de contacto
            dullShowMatrix.push(false); // [12] controla el modal de los datos STJ
            dullShowMatrix.push(false); //  [13] controla el modal de situaciones particulares de la hermana
            dullShowMatrix.push(false); // [14][n] controla los modales de situaciones particulares de la hermana
            dullShowMatrix.push(false); // [15] controla el modal de añadir etapas vida religiosa de la hermana
            dullShowMatrix.push(false); // [16][n] controla los modales de las diferentes etapas de la formación de la hermana
            dullShowMatrix.push(false); // [17] controla el modal de formacion religiosa de la hermana
            dullShowMatrix.push(false); // [18][n] controla los modales de las diferentes formaciones religiosas de la hermana
            dullShowMatrix.push(false);  // [19] modal comunidad
            dullShowMatrix.push(utils.falseArray(data.cargos.community)) // [20][n] modales comunidad
            dullShowMatrix.push(false);  // [21] modal provincia
            dullShowMatrix.push(utils.falseArray(data.cargos.province)); // [22][n] modales provincia
            dullShowMatrix.push(false);  // [23] modal equipo
            dullShowMatrix.push(utils.falseArray(data.cargos.workgroup)); // [24][n] modales equipo
            dullShowMatrix.push(false);  // [25] modal mision
            dullShowMatrix.push(utils.falseArray(data.cargos.mission)); // [26][n] modales mision

        }
        setShowModalMatrix(dullShowMatrix);
    }


    useEffect(() => {
        const fn = async () => {
            const data = await getUserData(userID, props.ErrorHandling);
            setDatosUsuario(data);
            loadModalMatrix(data);
            setLoading(false);
        };
        fn();
    }
        , [userID]);

    // Método Set, se encargan de actualizar el estado de este componente cuando se edita en los hijos
    // Usuarios
    const setDatosPersonales = (response) => {
        //console.log('aaaa')
        //console.log(response)
        response.datosTipoFormacion = DatosUsuario.datosTipoFormacion;
        response.datosInformatica = DatosUsuario.datosInformatica;
        response.datosIdiomas = DatosUsuario.datosIdiomas;
        response.active = DatosUsuario.active;
        //console.log('bbbb')
        //console.log(response)

        // Comprobamos que sea una hermana para no sobrescribir lo datos de la hermana
        if (DatosUsuario.sister) {
            response.sister = DatosUsuario.sister;
            response.datosPersonales = DatosUsuario.datosPersonales;
            response.datosTestamento = DatosUsuario.datosTestamento;
        }
        setDatosUsuario(response);
    }

    const setTipoFormacion = (response) => {
        setShowModalMatrix(prevState => {
            prevState[2].unshift(false);
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosTipoFormacion.estudios.unshift(response);
            return prevState;
        });
    }

    const setInformatica = (response) => {
        setShowModalMatrix(prevState => {
            prevState[4].unshift(false);
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosInformatica.unshift(response);
            return prevState;
        });
    }

    const setIdioma = (response) => {
        setShowModalMatrix(prevState => {
            prevState[6].unshift(false);
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosIdiomas.idiomas.unshift(response);
            return prevState;
        });
    }

    // Hermana
    const setDatosHermana = (response) => {
        setDatosUsuario(prevState => {
            prevState.sister = response;
            return prevState;
        });
    }

    const setSituacionParticular = (response) => {
        setShowModalMatrix(prevState => {
            prevState[14].unshift(false);
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosPersonales.unshift(response);
            return prevState;
        });
    }

    const setDatosTestamento = (response) => {
        setDatosUsuario(prevState => {
            prevState.datosTestamento = response;
            return prevState;
        });
    }

    const setEtapaVidaReligiosa = (response) => {
        setShowModalMatrix(prevState => {
            prevState[16].unshift(false);
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosEtapasReligiosas.unshift(response);
            return prevState;
        });
    }

    const setFormacionReligiosa = (response) => {
        setShowModalMatrix(prevState => {
            prevState[18].unshift(false);
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosFormacionReligiosa.unshift(response);
            return prevState;
        });
    }

    // Funciones PUT que editan los desplegables de desplegables
    // Usuarios
    const putTipoFormacion = (response, id) => {
        setDatosUsuario(prevState => {
            prevState.datosTipoFormacion.estudios[id] = response;
            return prevState;
        });
    }

    const putInformatica = (response, id) => {
        setDatosUsuario(prevState => {
            prevState.datosTipoFormacion.datosInformatica[id] = response;
            return prevState;
        });
    }

    const putIdioma = (response, id) => {
        setDatosUsuario(prevState => {
            prevState.datosIdiomas.idiomas[id] = response;
            return prevState;
        });
    }

    // Hermanas

    const putSituacionParticular = (response, id) => {
        setDatosUsuario(prevState => {
            prevState.datosPersonales[id] = response;
            return prevState;
        });
    }

    const putEtapaVidaReligiosa = (response, id) => {
        setDatosUsuario(prevState => {
            prevState.datosEtapasReligiosas[id] = response;
            return prevState;
        });
    }

    const putFormacionReligiosa = (response, id) => {
        setDatosUsuario(prevState => {
            prevState.datosFormacionReligiosa[id] = response;
            return prevState;
        });
    }

    // DELETE para eliminar aquellos desplegables de desplegables
    // Usuarios
    const deleteTipoFormacion = (id) => {
        setShowModalMatrix(prevState => {
            prevState[2].shift();
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosTipoFormacion.estudios.splice(id, 1);
            return prevState;
        });
    }

    const deleteInformatica = (id) => {
        setShowModalMatrix(prevState => {
            prevState[4].shift();
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosInformatica.splice(id, 1);
            return prevState;
        });
    }

    const deleteIdioma = (id) => {
        setShowModalMatrix(prevState => {
            prevState[6].shift();
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosIdiomas.idiomas.splice(id, 1);
            return prevState;
        });
    }

    // Hermanas
    const deleteSituacionParticular = (id) => {
        setShowModalMatrix(prevState => {
            prevState[14].shift();
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosPersonales.splice(id, 1);
            return prevState;
        });
    }

    const deleteEtapaVidaReligiosa = (id) => {
        setShowModalMatrix(prevState => {
            prevState[16].shift();
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosEtapasReligiosas.splice(id, 1);
            return prevState;
        });
    }

    const deleteFormacionReligiosa = (id) => {
        setShowModalMatrix(prevState => {
            prevState[18].shift();
            return prevState;
        });
        setDatosUsuario(prevState => {
            prevState.datosFormacionReligiosa.splice(id, 1);
            return prevState;
        });
    }

    // Pasamos elemento e -> Contiene los datos del codigo html
    const onError = (e) => {
        if (DatosUsuario.sister || DatosUsuario.type === "Monja") {
            e.target.onerror = null;
        }

        e.target.src = FotoPorDefecto();

        setDatosUsuario(prevState => {
            prevState.photo = FotoPorDefecto();
            return prevState;
        });
    }

    // Funcion que se encarga de controlar la matriz de los modales
    const handleButtonShow = (event) => {
        // Creamos una matriz auxiliar
        let showModalMatrixAux = [...showModalMatrix];

        // Recibimios un id que se corresponde con la posicion de la matriz
        // en la que se encuentra el showModal.
        // En caso de ser un desplegables de desplegables recibimo tambien el value
        // que nos indica la posicion del array dentro del array
        if (event) {
            if (event.target.value) {
                // Si es un desplegable de desplegables
                let fil = event.target.value;
                let col = event.target.id;
                showModalMatrixAux[fil][col] = showModalMatrix[fil][col];
            } else {
                // Si no lo es
                showModalMatrixAux[event.target.id] = !showModalMatrix[event.target.id];
            }
        }

        //Si el evento es nulo o es cerrar ponemos todo a false
        if (event === undefined || event.target.name === "Cerrar") {
            for (let i = 0; i < showModalMatrixAux.length; i++) {
                if (showModalMatrixAux[i] === true || showModalMatrixAux[i] === false) {
                    // Si es un booleano lo pasamos a false
                    showModalMatrixAux[i] = false;
                }
                for (let j = 0; j < showModalMatrixAux[i].length; j++) {
                    // Si es un array lo recorremos y lo ponemos a false
                    showModalMatrixAux[i][j] = false;
                }
            }
        }
        setShowModalMatrix(showModalMatrixAux);
    }

    // Función que cambia una variable del estado a null tambn se hace a dos niveles, en caso de foto la pone por defecto
    const nullField = (field, secondOrder) => {

        if (secondOrder === "photo") {
            setDatosUsuario(prevState => {
                prevState.photo = FotoPorDefecto();
                return prevState;
            })

        } else if (secondOrder !== null) {
            setDatosUsuario(prevState => {
                prevState[secondOrder][field] = null;
                return prevState;
            })
        } else {
            setDatosUsuario(prevState => {
                prevState[field] = null;
                return prevState;
            })
        }
    }

    const FotoPorDefecto = () => {
        if (DatosUsuario.type === "Monja") {
            return "/images/nun.png";
        } else if (DatosUsuario.gender === "h") {
            return "/images/laico1.png";
        } else if (DatosUsuario.gender === "m") {
            return "/images/laico2.png";
        }
    }

    const generatePDF = async (sisterId, xls) => {
        setLoading(true)
        await informeHermanaCompleto(sisterId, xls)
        setLoading(false)
    }

    //Comprobamos si eres admin, false si estas en perfil y accessLevel menor de 10
    let esAdmin = !(props.ruta === "perfil" && props.perfil.accessLevel < 9);
    let esMonja = DatosUsuario.type === "Monja";
    return (
        <React.Fragment>

            {// console.log(esAdmin,' ',esMonja)
            }

            {DatosUsuario && !loading && (
                <Container>
                    {!DatosUsuario.active &&
                        <Alert variant={"warning"}>{DatosUsuario.type === "Monja" ? `La hermana se encuentra inactiva de la congregación.` : `El laico/a se encuentra inactivo/a de la Congregación.`}</Alert>}
                    <Row bg="light" className="shadow-lg mx-3 my-5 align-items-center">
                        <Col className="d-flex justify-content-center" xs={12} sm={12} lg={6}>
                            <Image
                                className="img-fluid-detalle-hermana"
                                src={
                                    DatosUsuario.photo ? process.env.REACT_APP_API_URL + "/download/usuarios/" + DatosUsuario.id + "?name=" + DatosUsuario.photo : FotoPorDefecto()
                                }
                                onError={(e) => onError(e)}
                                alt="nunIcon"
                            />
                        </Col>
                        <Col xs={12} sm={12} lg={6}>
                            <h5 className="detail-title-sister">{DatosUsuario.name + " " + DatosUsuario.firstSurname + " " + DatosUsuario.secondSurname}</h5>
                            {DatosUsuario.birthCountry && (
                                <h5 className="detail-title-sister">{DatosUsuario.birthCountry +
                                    (DatosUsuario.birthProvince ? ", " + DatosUsuario.birthProvince : "") +
                                    (DatosUsuario.birthAddress ? ", " + DatosUsuario.birthAddress : "")}</h5>
                            )}
                            {
                            }
                            {DatosUsuario.adscripcionDestino && DatosUsuario.adscripcionDestino[0] && (
                                <h5 className="detail-title-sister">{`${DatosUsuario.adscripcionDestino[0]?.community?.name}${DatosUsuario.adscripcionDestino[0]?.community?.name && ","} ${DatosUsuario.adscripcionDestino[0]?.province?.name}`}</h5>
                            )}
                            {//console.log(DatosUsuario)
}
                            {DatosUsuario.type === "Monja" && <Button variant="outline-info" onClick={() => {generatePDF(DatosUsuario.sister.id, false)}}>Informe detallado PDF</Button>}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Tabs>
                                <Tab eventKey="personales" title="Datos Personales">
                                    <Accordion>
                                        <DesplegableDatosPersonales
                                            state={{ DatosUsuario, showModalMatrix }}
                                            handleButtonShow={handleButtonShow}
                                            setDatosPersonales={setDatosPersonales}
                                            setAlert={props.setAlert}
                                            ErrorHandling={props.ErrorHandling}
                                            nullField={nullField}
                                        />
                                        {DatosUsuario.sister && DatosUsuario.type === "Monja" && (
                                            <React.Fragment>
                                                <DesplegableSacramental
                                                    state={{ DatosUsuario, showModalMatrix }}
                                                    handleButtonShow={handleButtonShow}
                                                    setDatosHermana={setDatosHermana}
                                                    nullField={nullField}
                                                    setAlert={props.setAlert}
                                                    ErrorHandling={props.ErrorHandling}
                                                />
                                                {esAdmin && (
                                                    <DesplegableDeceso
                                                        state={{ DatosUsuario, showModalMatrix }}
                                                        handleButtonShow={handleButtonShow}
                                                        setDatosHermana={setDatosHermana}
                                                        nullField={nullField}
                                                        setAlert={props.setAlert}
                                                        ErrorHandling={props.ErrorHandling}
                                                    />
                                                )}
                                                <DesplegableTestamento
                                                    state={{ DatosUsuario, showModalMatrix }}
                                                    handleButtonShow={handleButtonShow}
                                                    setDatosTestamento={setDatosTestamento}
                                                    nullField={nullField}
                                                    setAlert={props.setAlert}
                                                    ErrorHandling={props.ErrorHandling}
                                                    esAdmin={esAdmin}
                                                />
                                            </React.Fragment>
                                        )}
                                    </Accordion>
                                </Tab>
                                {esMonja && (
                                    <Tab eventKey="familiares" title="Datos Familiares y Contacto">
                                        <Accordion>
                                            <DesplegableFamiliares
                                                state={{ DatosUsuario, showModalMatrix }}
                                                handleButtonShow={handleButtonShow}
                                                setDatosHermana={setDatosHermana}
                                                nullField={nullField}
                                                setAlert={props.setAlert}
                                                ErrorHandling={props.ErrorHandling}
                                            />
                                            <DesplegableContacto
                                                state={{ DatosUsuario, showModalMatrix }}
                                                handleButtonShow={handleButtonShow}
                                                setDatosHermana={setDatosHermana}
                                                nullField={nullField}
                                                setAlert={props.setAlert}
                                                ErrorHandling={props.ErrorHandling}
                                            />
                                        </Accordion>
                                    </Tab>
                                )}
                                {esMonja && (
                                    <Tab eventKey="religiosa" title="Vida Religiosa">
                                        <Accordion>
                                            <DesplegableDatosSTJ
                                                state={{ DatosUsuario, showModalMatrix }}
                                                handleButtonShow={handleButtonShow}
                                                setDatosHermana={setDatosHermana}
                                                nullField={nullField}
                                                esAdmin={esAdmin}
                                                setAlert={props.setAlert}
                                                ErrorHandling={props.ErrorHandling}
                                            />

                                            <EtapasVidaReligiosa
                                                esMonja={esMonja}
                                                userId={userID}
                                                hermanaId={DatosUsuario.sister.id}
                                                datosUsuario={DatosUsuario}
                                                accessLevel={props.perfil.accessLevel} />

                                            <SituacionesParticulares
                                                accessLevel={props.perfil.accessLevel}
                                                state={{ DatosUsuario, showModalMatrix }}
                                                idHermana={DatosUsuario.sister.id} />

                                            {/*<DesplegableAdscripcion state={{ DatosUsuario, showModalMatrix }} />*/}

                                            <DestinoHermana
                                                esMonja={esMonja}
                                                userId={userID}
                                                hermanaId={DatosUsuario.sister.id}
                                                datosUsuario={DatosUsuario}
                                                accessLevel={props.perfil.accessLevel} />

                                            {/* // */}
                                            <Accordion>
                                                <Card>
                                                    <Card.Header>
                                                        <Accordion.Toggle as={Button} eventKey="100" variant="link">
                                                            Servicios Vida Religiosa
                                                        </Accordion.Toggle>
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey="100">
                                                        <Card.Body>
                                                            <VidaReligiosa idUsuario={userID} />
                                                            {/* <Alert variant={"info"}>Apartado actualmente en construcción</Alert> */}
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                            {/* // */}
                                            <DesplegableFormacionReligiosa
                                                state={{ DatosUsuario, showModalMatrix }}
                                                handleButtonShow={handleButtonShow}
                                                setFormacionReligiosa={setFormacionReligiosa}
                                                putFormacionReligiosa={putFormacionReligiosa}
                                                deleteFormacionReligiosa={deleteFormacionReligiosa}
                                                ErrorHandling={props.ErrorHandling}
                                                esAdmin={esAdmin}
                                                setAlert={props.setAlert}
                                            />
                                        </Accordion>
                                    </Tab>
                                )}
                                <Tab eventKey="formacion" title="Datos Formación">
                                    <Accordion>
                                        <DesplegableTipoFormacion
                                            state={{ DatosUsuario, showModalMatrix }}
                                            handleButtonShow={handleButtonShow}
                                            setTipoFormacion={setTipoFormacion}
                                            putTipoFormacion={putTipoFormacion}
                                            deleteTipoFormacion={deleteTipoFormacion}
                                            setAlert={props.setAlert}
                                            ErrorHandling={props.ErrorHandling}
                                        />
                                        <DesplegableFormacionAdicional
                                            state={{ DatosUsuario, showModalMatrix }}
                                            handleButtonShow={handleButtonShow}
                                            setInformatica={setInformatica}
                                            setIdioma={setIdioma}
                                            putInformatica={putInformatica}
                                            putIdioma={putIdioma}
                                            deleteInformatica={deleteInformatica}
                                            deleteIdioma={deleteIdioma}
                                            setAlert={props.setAlert}
                                            ErrorHandling={props.ErrorHandling}
                                        />
                                        {
                                            // TODO: Mover a componente individual cuando esten la API lista
                                        }
                                        <CursosCompania accessLevel={props.perfil.accessLevel}
                                            state={{ DatosUsuario, showModalMatrix }}
                                            //idHermana={DatosUsuario?.sister?.id} 
                                            idUsuario={userID} />
                                        {/*
                                        <Accordion>
                                            <Card>
                                                <Card.Header>
                                                    <Accordion.Toggle as={Button} eventKey={100} variant="link">
        Cursos organizados por la compañía{" "}
                                                    </Accordion.Toggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey={100}>
                                                    <Card.Body>
                                                        <CursosCompania idUsuario={userID} />
                                                        Información sobre los cursos organizados por la compañía
                                                        {/*<Alert variant={"info"}>Apartado actualmente en
                                                            construcción</Alert>}
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>// */}
                                        {/* // */}
                                        {/* <Desplegable Text={"Información sobre los cursos organizados por la compañía"} Toogle="Cursos organizados por la compañía" Form={null} canEdit={true} boton="Añadir" /> */}
                                    </Accordion>
                                </Tab>
                                {/* // */}

                                {!esMonja && DatosUsuario.cargos && (
                                    <Tab eventKey="mision" title={"Trabajo"}>

                                        {DatosUsuario?.cargos?.province[0] && <DesplegableCargos eventKey={"21"} showModalMatrix={showModalMatrix}
                                            name={"Provincia"} cargos={DatosUsuario.cargos.province} />}
                                        {DatosUsuario?.cargos?.workgroup[0] && <DesplegableCargos eventKey={"23"} showModalMatrix={showModalMatrix}
                                            name={"Equipo"} cargos={DatosUsuario.cargos.workgroup} />}
                                        {DatosUsuario?.cargos?.mission[0] && <DesplegableCargos eventKey={"25"} showModalMatrix={showModalMatrix}
                                            name={"Obra/Proyecto"} cargos={DatosUsuario.cargos.mission} />}
                                    </Tab>
                                )}

                                {/*!esMonja && (
                                    <Tab eventKey="mision" title={"Trabajo"}>
                                        <Alert variant={"info"}>Apartado actualmente en construcción</Alert>
                                    </Tab>
                                )}
                                {/* // */}
                                {/* <Tab eventKey="mision" title={esMonja ? "Misión" : "Trabajo"}>
                    <Desplegable Toogle={esMonja ? "Misión" : "Trabajo"} Text={"Datos de la misión"} Form={null} canEdit={false} />
                  </Tab> */}

                                {!esMonja && (
                                    <Tab eventKey="destino" title={"Destino"}>
                                        <DestinoLaico esMonja={esMonja} userId={userID} datosUsuario={DatosUsuario} accessLevel={props.perfil.accessLevel}></DestinoLaico>
                                    </Tab>

                                )}
                                {props.ruta === "perfil" && DatosUsuario && (
                                    <Tab eventKey="seguridad" title="Seguridad">
                                        <Desplegable
                                            Toogle={"Cambio de Contraseña"}
                                            Text={<TabCambioContrasena perfil={props.perfil} setAlert={props.setAlert}
                                                ErrorHandling={props.ErrorHandling} />}
                                            Form={null}
                                            canEdit={false}
                                        />
                                    </Tab>
                                )}
                                {//console.log(DatosUsuario?.cargos)
                                }

                                {esMonja && DatosUsuario.cargos && (


                                    <Tab eventKey="mision" title={"Misión"}>
                                        {DatosUsuario?.cargos?.community[0] && <DesplegableCargos eventKey={"19"} showModalMatrix={showModalMatrix}
                                            name={"En Comunidad"} cargos={DatosUsuario.cargos.community} />}
                                        {DatosUsuario?.cargos?.province[0] && <DesplegableCargos eventKey={"21"} showModalMatrix={showModalMatrix}
                                            name={"En Provincia o D. G."} cargos={DatosUsuario.cargos.province} />}
                                        {DatosUsuario?.cargos?.workgroup[0] && <DesplegableCargos eventKey={"23"} showModalMatrix={showModalMatrix}
                                            name={"En Equipos o Comisiones"} cargos={DatosUsuario.cargos.workgroup} />}
                                        {DatosUsuario?.cargos?.mission[0] && <DesplegableCargos eventKey={"25"} showModalMatrix={showModalMatrix}
                                            name={"En Obras o Proyectos"} cargos={DatosUsuario.cargos.mission} />}
                                        {
                                            //112022 para otra misión
                                        }
                                        {<MisionExtra
                                            accessLevel={props.perfil.accessLevel}
                                            state={{ DatosUsuario, showModalMatrix }}
                                            sisterId={DatosUsuario.sister.id}
                                            userId={DatosUsuario.id}
                                        />
                                        }


                                    </Tab>

                                )}

                            </Tabs>
                        </Col>
                    </Row>
                </Container>
            )}
        </React.Fragment>
    );
}

export default Usuario;